import { useWeb3React } from "@web3-react/core";
import { useCallback, useEffect, useState } from "react";
import { ILocalStorageSnapshot } from "../../types";
import { Paragraph } from "../styled/Text";
import { WrappedRow, ViewMore } from "./styled";
import styled from "styled-components";
import { Row } from "../styled/Flex";
import { FormHeadline } from "../styled/Form";
import { useDispatch } from "react-redux";
import { Dispatch } from "../../store";
import { useNavigate } from "react-router-dom";
import Button from "../styled/Button";

const SnapshotHistoryContainer = styled.div`
  display: flex;
  margin-top: 25px;
  flex-direction: column;
`;
const snapshotPerSection = 3;

const SnapshotHistory = ({
  historyData,
}: {
  historyData: ILocalStorageSnapshot[];
}) => {
  const { chainId } = useWeb3React();
  const [next, setNext] = useState(snapshotPerSection);
  const [filteredData, setFilteredData] = useState<ILocalStorageSnapshot[]>([]);

  const dispatch = useDispatch<Dispatch>();
  const navigator = useNavigate();

  useEffect(() => {
    if (chainId) {
      const filtered = historyData
        .filter((item) => item.chainId === chainId)
        .sort((a, b) => b.timestamp - a.timestamp);
      setFilteredData(filtered);
    }

    return () => {
      setFilteredData([]);
    };
    // eslint-disable-next-line
  }, [chainId, historyData]);

  const handleLoadMore = () => {
    setNext(next + snapshotPerSection);
  };

  const handleHistorySnapshot = useCallback(
    (id: string) => {
      dispatch.snapshotModel.setCurrentSnapshotId(id);
      navigator("/processing");
    },
    [dispatch, navigator]
  );

  if (!filteredData.length) {
    return null;
  }

  return (
    <SnapshotHistoryContainer>
      <Row>
        <FormHeadline>Snapshot History</FormHeadline>
      </Row>
      {filteredData?.slice(0, next)?.map((item, index) => {
        return (
          <WrappedRow
            alignItems="start"
            justify="flex-start"
            direction="column"
            onClick={() => handleHistorySnapshot(item.snapshotId)}
            key={index}
          >
            <Paragraph>
              <b>Snapshot ID:</b> {item.snapshotId}
            </Paragraph>
            <Paragraph>
              <b>Creation date: {new Date(item.timestamp).toLocaleString()}</b>
            </Paragraph>

            <ViewMore>View snapshot</ViewMore>
          </WrappedRow>
        );
      })}
      <WrappedRow>
        {next < filteredData?.length && (
          <Button onClick={handleLoadMore}>Load More</Button>
        )}
      </WrappedRow>
    </SnapshotHistoryContainer>
  );
};

export default SnapshotHistory;
